import { AppBar, styled, Toolbar } from '@mui/material';
import { PropsWithChildren } from 'react';

export default function StickyBottomActionContainer(props: PropsWithChildren<unknown>) {
    return (
        <StyledAppBar position="fixed">
            <Toolbar>
                { props.children }
            </Toolbar>
        </StyledAppBar>
    );
}

const StyledAppBar = styled(AppBar)(({ theme }) => ({
    top: 'auto',
    bottom: 0,
    boxShadow: theme.shadows[4],
    padding: theme.spacing(2)
}));
